/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Zany_Hedgehog_OfferInputs */

const fr_stock_zany_hedgehog_offer = /** @type {(inputs: Stock_Zany_Hedgehog_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton temps max`)
};

/**

* @param {Stock_Zany_Hedgehog_OfferInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const stock_zany_hedgehog_offer = /** @type {((inputs?: Stock_Zany_Hedgehog_OfferInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Zany_Hedgehog_OfferInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_stock_zany_hedgehog_offer(inputs)
});